module.exports = __webpack_public_path__ + "img/CM-JN-24-Hyundai-Lifestyle.3f841e62.jpg";